import apiClient from "../axios";

export const api = {
    getLimits: () => {
        return apiClient.get(`/badge-center/limits`).then((res) => res.data);
    },
    getXpBreakdown: (sessionId: string) => {
        return apiClient.get(`/badge-center/sessions/${sessionId}/xp-breakdown`).then((res) => res.data);
    },
    getBadgeCenterNotifications: () => {
        return apiClient.get(`/badge-center/notifications/poll`).then((res) => res.data);
    },
    getXPProgress: () => {
        const url = `/badge-center/xp`;
        return apiClient.get(url);
    },
    getUserState: () => {
        const url = `/sessions/user-state`;
        return apiClient.get(url);
    },
    getActiveView: () => {
        const url = `/badge-center/active-view`;
        return apiClient.get(url).then((res) => res.data);
    },
    getAchievementsQuickView: (count: number) => {
        const url = `/badge-center/achievements/quick-view?count=${count}`;
        return apiClient.get(url).then((res) => res.data);
    },
    getAchievements: (filter?: string) => {
        let url = `/badge-center/achievements`;
        if (filter && filter !== "all") {
            url += `?filter=${filter}`;
        }
        return apiClient.get(url).then((res) => res.data);
    },
    getTierProgress: () => {
        const url = `/badge-center/tier-progress`;
        return apiClient.get(url).then((res) => res.data);
    },
    getWeeklyGoals: () => {
        const url = `/badge-center/goals/weekly`;
        return apiClient.get(url).then((res) => res.data);
    },
    getWeeklyGoalsWarning: () => {
        const url = `badge-center/goals/weekly/warning`;
        return apiClient.get(url).then((res) => res.data);
    },
    getGoalsLevel: () => {
        const url = `/badge-center/goals/level`;
        return apiClient.get(url).then((res) => res.data);
    },
    getOnboardingStatus: () => {
        const url = `/badge-center/onboarding/status`;
        return apiClient.get(url).then((res) => res.data);
    },
    getOnboardingCards: () => {
        const url = `/badge-center/onboarding/cards`;
        return apiClient.get(url).then((res) => res.data);
    },
    acknowledgeOnboarding: () => {
        const url = `/badge-center/onboarding/acknowledge`;
        return apiClient.post(url);
    },
}
